import { Route } from '@angular/router';
import { IndexPage } from 'app/modules/corrective-maintenance/pages/index/index.page';
import { GeneralPage } from 'app/modules/corrective-maintenance/pages/general/general.page';
import { CmEmergingPage } from 'app/modules/corrective-maintenance/pages/cm-emerging/cm-emerging.page';
import { CmBaselinePage } from 'app/modules/corrective-maintenance/pages/cm-baseline/cm-baseline.page';
import { FailureNotificationPage } from 'app/modules/corrective-maintenance/pages/failure-notification/failure-notification.page';
import { CmEditPage } from 'app/modules/corrective-maintenance/pages/cm-edit/cm-edit.page';
import { CMDashboardPage } from 'app/modules/corrective-maintenance/pages/cm-dashboard/cm-dashboard.page';
import { CmFieldSummaryComponent } from 'app/modules/corrective-maintenance/component/field-summary/field-summary.page';
import { CmStringSummaryComponent } from 'app/modules/corrective-maintenance/component/string-summary/string-summary.page';

export const cmDashboardRoutes: Route[] = [
    {
        path: 'cm-dashboard',
        component: CMDashboardPage,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'field',
            },
            {
                path: 'field',
                component: CmFieldSummaryComponent,
             },
             {
                path: 'string',
                component: CmStringSummaryComponent,
             } 
        ],
    },
];

export const cmDataManagementRoutes: Route[] = [
    {
        path: 'corrective-maintenance',
        component: IndexPage,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'baseline',
            },
            {
                path: 'general',
                component: GeneralPage,
            },
            {
                path: 'baseline',
                component: CmBaselinePage,
            },
            {
                path: 'emerging',
                component: CmEmergingPage,
            },
            {
                path: 'failure-notification',
                component: FailureNotificationPage,
            },

        ]
    },
    // {
    //     path: 'corrective-maintenance/:id/edit',
    //     component: CmEditPage
    // },
    {
        path: 'corrective-maintenance/:id/:action',
        component: CmEditPage
    }
];

export const cmConfigurationRoutes: Route[] = [
    {
        path: 'corrective-maintenance',
        children: [],
    },
];
